// 资产首页
export const PROPERTIES_TRACING = {
  transactionRecord: {
    eventId: 'propertiesTransactionRecord',
    title: '资产首页-点击-交易记录',
  },
  reportsAndInfos: {
    eventId: 'reportsAndInfos',
    title: '资产首页-点击-报告与资讯',
  },
  myAppoints: {
    eventId: 'myAppoints',
    title: '资产首页-点击-我的预约',
  },
  moreNews: {
    eventId: 'moreInfos',
    title: '资产首页-点击-更多最新消息',
  },
  hornNews: {
    eventId: 'propertiesHornNews',
    title: '资产首页-点击-喇叭最新消息',
  },
  historyQuery: {
    eventId: 'propertiesHistoryQuery',
    title: '资产首页-点击-历史查询',
  },
  assetList: {
    eventId: 'propertiesAssetList',
    title: '资产首页-点击-资产列表',
  },
  // noticeNews: {
  //   eventId: 'propertiesNoticeNews',
  //   title: '资产首页-点击-通知最新消息',
  // },
}

// 详情埋点
export const PROGRESS_PASSAGE_TRACING = {
  history: {
    eventId: 'processingOrderHistory',
    title: '进行中的预约-点击-查看历史预约',
  },
  orderDetailButton: {
    eventId: 'orderDetailButton',
    title: '点击-预约详情按钮',
  },
  reservationShareFile: {
    eventId: 'reservationShareFile',
    title: '预约详情——份额确认书',
  },
  reservationReturnSure: {
    eventId: 'reservationReturnSure',
    title: '预约详情——回访——点击确定',
  },
  reservationDrawnView: {
    eventId: 'reservationDrawnView',
    title: '预约详情——打款——查看基金募集账户',
  },
  baseInfoFromOrder: {
    eventId: 'baseInfoFromOrder',
    title: '预约详情——重新确认投资者基本信息',
  },
  reservationPurchaseSign: {
    eventId: 'reservationPurchaseSign',
    title: '预约详情——认申购——签署',
  },
  reservationPurchaseView: {
    eventId: 'reservationPurchaseView',
    title: '预约详情——认申购——查看',
  },
  reservationSuitablySign: {
    eventId: 'reservationSuitablySign',
    title: '预约详情——适当性——查看签署',
  },
  reservationSuitablyUpload: {
    eventId: 'reservationSuitablyUpload',
    title: '预约详情——适当性——上传',
  },
  reservationSignatureFail: {
    eventId: 'reservationSignatureFail',
    title: '预约详情——电子签名——重新设置电子签名',
  },
  reservationSignatureSetUp: {
    eventId: 'reservationSignatureSetUp',
    title: '预约详情——电子签名——设置',
  },
  shareConfirmButton: {
    eventId: 'shareConfirmButton',
    title: '纸质-查看份额确认书-按钮',
  },
  customReDualRecord: {
    eventId: 'custom_reDualRecord',
    title: '点击重新录音录像确认按钮',
  },
  clickDualRecordBtn: {
    eventId: 'clickDualRecordBtn',
    title: '点击开始录音录像确认按钮',
  },
  orderDetailsModify: {
    eventId: 'orderDetailsModify',
    title: '预约详情-点击-修改',
  },
  orderDetailsRevoke: {
    eventId: 'orderDetailsRevoke',
    title: '预约详情-点击-撤销',
  },
}

// 消息通知
export const MESSAGE_TRACING = {
  recentAnnouncements: {
    eventId: 'recentAnnouncements',
    title: '近期公告列表',
  },
  singleProductAnnouncements: {
    eventId: 'singleProductAnnouncements',
    title: '单个产品公告列表',
  },
  recentReports: {
    eventId: 'recentReports',
    title: '近期报告列表',
  },
  singleProductReports: {
    eventId: 'singleProductReports',
    title: '单个产品报告列表',
  },
  productInformation: {
    eventId: 'productInformation',
    title: '近期资讯列表',
  },
  readInfo: {
    eventId: 'readInfo',
    title: '点击-单个查看资讯',
  },
  readAnnouncement: {
    eventId: 'readAnnouncement',
    title: '点击-单个查看公告',
  },
  readReport: {
    eventId: 'readReport',
    title: '点击-单个查看报告',
  },
}

// 产品详情
export const PRODUCT_DETAIL_TRACING = {
  subscribe: {
    eventId: 'productDetailSubscribe',
    title: '产品信息-点击-认购',
  },
  purchase: {
    eventId: 'productDetailPurchase',
    title: '产品信息-点击-申购',
  },
  redeemFund: {
    eventId: 'productDetailRedeemFund',
    title: '产品信息-点击-赎回',
  },
  addApply: {
    eventId: 'productDetailAddApply',
    title: '产品信息-点击-追加',
  },
  netWorth: {
    eventId: 'productDetailNetWorth',
    title: '产品信息-点击-产品净值走势',
  },
  scale: {
    eventId: 'productDetailScale',
    title: '产品信息-点击-产品规模走势',
  },
  electronKindReminder: {
    eventId: 'electronKindReminder',
    title: '产品信息-点击电子合同[温馨提示]的确定按钮',
  },
  productContact: {
    eventId: 'productContact',
    title: '产品信息-点击-产品合同',
  },
};

// 认申购步骤埋点
export const BUY_STEP_TRACING = {
  appendApplyAdd: {
    eventId: 'appendApplyAdd',
    title: '新增追加预约',
  },
  subscribeApplyAdd: {
    eventId: 'subscribeApplyAdd',
    title: '新增认申购预约',
  },
  buyStepPersonSubmit: {
    eventId: 'buyStepPersonSubmit',
    title: '确认个人信息-点击-提交按钮',
  },
  buyStepAppointmentSubmit: {
    eventId: 'buyStepAppointmentSubmit',
    title: '填写预约信息-点击-提交按钮',
  },
  buyStepAppointmentConfirm: {
    eventId: 'buyStepAppointmentConfirm',
    title: '填写预约信息-点击-二次确定按钮',
  },
  buyStepSetSignature: {
    eventId: 'buyStepSetSignature',
    title: '认申购步骤-点击设置签名',
  },
  buyStepAgainSignature: {
    eventId: 'buyStepAgainSignature',
    title: '认申购步骤-点击-重新签名',
  },
  buyStepSignatureSubmit: {
    eventId: 'buyStepSignatureSubmit',
    title: '认申购步骤-点击-签名提交',
  },
  submitSignaturePassword: {
    eventId: 'submitSignaturePassword',
    title: '认申购步骤-点击-签名密码提交',
  },
  submitSignatureSignPassword: {
    eventId: 'submitSignatureSignPassword',
    title: '认申购步骤-签署-点击签名密码提交',
  },
  submitSignatureEnterPassword: {
    eventId: 'submitSignatureEnterPassword',
    title: '认申购步骤-签署-输入签名密码完成',
  },
  forgetPwdSubmit: {
    eventId: 'forgetPwdSubmit',
    title: '重新设置签署密码-提交',
  },
  submitSignatureSign: {
    eventId: 'submitSignatureSign',
    title: '认申购步骤-点击签署文件',
  },
  uploadProveFile: {
    eventId: 'uploadProveFile',
    title: '上传资质证明文件 — 上传按钮',
  },
  attestationAssetsReturn: {
    eventId: 'attestationAssetsReturn',
    title: '认证上传资质证明文件 - 返回修改',
  },
  attestationAssetsConfirm: {
    eventId: 'attestationAssetsConfirm',
    title: '认证上传资质证明文件 - 确认无误',
  },
  fileProveList: {
    eventId: 'fileProveList',
    title: '签署适当性文件——签署按钮',
  },
  goToDualRecordWeapp: {
    eventId: 'goToDualRecordWeapp',
    title: '跳转录音录像确认小程序',
  },
  doubleRecordingDeny: {
    eventId: 'doubleRecordingDeny',
    title: '录音录像弹框点击《否》',
  },
  doubleRecordingCorrect: {
    eventId: 'doubleRecordingCorrect',
    title: '录音录像弹框点击《是》',
  },
  returnVisitConfirm: {
    eventId: 'returnVisitConfirm',
    title: '回访确认 - 点击确认',
  },
  returnVisitQuickInput: {
    eventId: 'returnVisitQuickInput',
    title: '回访确认 - 一键输入',
  },
}

// 验证身份信息界面埋点
export const IDENTITY_VERIFICATION_TRACING = {
  faceButton: {
    eventId: 'identityVerificationFaceButton',
    title: '认证方式-点击-人脸识别按钮',
  },
  totodiFace: {
    eventId: 'totodiFace',
    title: '妥妥递人脸',
  },
  faceVerification: {
    eventId: 'faceVerification',
    title: '人脸识别认证-点击-开始认证按钮',
  },
  bankButton: {
    eventId: 'identityVerificationBankButton',
    title: '认证方式-点击-银行卡认证按钮',
  },
  bankVerification: {
    eventId: 'bankVerification',
    title: '银行卡认证-点击-开始认证按钮',
  },
  bankInformationSubmit: {
    eventId: 'bankInformationSubmit',
    title: '银行卡认证-点击-信息提交按钮',
  },
}


// 我的页面
export const MY_INFOS_TRACING = {
  contactUs: {
    eventId: 'contactUs',
    title: '联系我们 ',
  },
  logoutMobile: {
    eventId: 'logoutMobile',
    title: '退出登录',
  },
}

// 短信验证码
export const CAPTCHA_DATA = {
  smsCaptcha: {
    eventId: 'smsCaptcha',
    title: '短信验证码',
  },
  voiceCaptcha: {
    eventId: 'voiceCaptcha',
    title: '语音验证码',
  },
  emailCaptcha: {
    eventId: 'emailCaptcha',
    title: '邮箱验证码',
  },
}